export default "__VITE_ASSET__a28cd396__"